import React from "react";

export const DataManagement = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_472_2067)">
        <path
          d="M1.79999 1.71497H1.54285C1.25882 1.71497 1.02856 1.94522 1.02856 2.22925V4.28457C1.02856 4.56861 1.25882 4.79886 1.54285 4.79886H1.79999C2.08403 4.79886 2.31428 4.56861 2.31428 4.28457V2.22925C2.31428 1.94522 2.08403 1.71497 1.79999 1.71497Z"
          fill="#3377FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.59999 1.71497C3.88402 1.71497 4.11428 1.94522 4.11428 2.22925V2.48563C4.11428 2.76967 3.88402 2.99992 3.59999 2.99992H1.54285C1.25882 2.99992 1.02856 2.76967 1.02856 2.48563V2.22925C1.02856 1.94522 1.25882 1.71497 1.54285 1.71497H3.59999Z"
          fill="#3377FF"
        />
        <path
          d="M21.5991 2.48542V2.22828C21.5991 1.94424 21.3689 1.71399 21.0848 1.71399L19.0295 1.71399C18.7455 1.71399 18.5152 1.94424 18.5152 2.22828V2.48542C18.5152 2.76945 18.7455 2.9997 19.0295 2.9997H21.0848C21.3689 2.9997 21.5991 2.76945 21.5991 2.48542Z"
          fill="#3377FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5989 4.28542C21.5989 4.56944 21.3687 4.7997 21.0846 4.7997H20.8283C20.5442 4.7997 20.314 4.56944 20.314 4.28542V2.22828C20.314 1.94424 20.5442 1.71399 20.8283 1.71399H21.0846C21.3687 1.71399 21.5989 1.94424 21.5989 2.22828V4.28542Z"
          fill="#3377FF"
        />
        <path
          d="M1.02954 21.5037V21.7609C1.02954 22.0449 1.25979 22.2751 1.54383 22.2751H3.59915C3.88318 22.2751 4.11343 22.0449 4.11343 21.7609V21.5037C4.11343 21.2197 3.88318 20.9894 3.59915 20.9894H1.54383C1.25979 20.9894 1.02954 21.2197 1.02954 21.5037Z"
          fill="#3377FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.02954 19.7037C1.02954 19.4197 1.25979 19.1895 1.54383 19.1895H1.80021C2.08424 19.1895 2.3145 19.4197 2.3145 19.7037V21.7609C2.3145 22.0449 2.08424 22.2752 1.80021 22.2752H1.54383C1.25979 22.2752 1.02954 22.0449 1.02954 21.7609V19.7037Z"
          fill="#3377FF"
        />
        <path
          d="M16.2302 13.8925C15.8811 13.7499 15.4823 13.9171 15.3395 14.2661C14.4133 16.5307 12.8709 17.9375 11.3142 17.9375C9.75747 17.9375 8.21509 16.5307 7.28883 14.2661C7.14613 13.9171 6.74739 13.7498 6.39815 13.8925C6.04895 14.0351 5.8816 14.4337 6.02437 14.7826C6.55172 16.0721 7.28543 17.1699 8.14607 17.9574C9.1081 18.8375 10.2036 19.3028 11.3142 19.3028C12.4247 19.3028 13.5203 18.8375 14.4823 17.9574C15.343 17.1699 16.0767 16.0721 16.604 14.7826C16.7467 14.4337 16.5794 14.0351 16.2302 13.8925Z"
          fill="#4BCFFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4404 11.1112H19.3742C19.7515 11.1112 20.0572 11.4169 20.0572 11.7939C20.0572 12.1709 19.7515 12.4765 19.3742 12.4765H16.6924L16.6908 12.4766L16.6884 12.4765H3.25457C2.87733 12.4765 2.57153 12.1709 2.57153 11.7939C2.57153 11.4169 2.87733 11.1112 3.25457 11.1112H5.18842C5.17437 10.8825 5.16706 10.6545 5.16706 10.4286C5.16706 7.04097 7.92477 4.28491 11.3144 4.28491C14.704 4.28491 17.4617 7.04097 17.4617 10.4286C17.4617 10.6545 17.4544 10.8825 17.4404 11.1112ZM11.3144 5.6502C8.67802 5.6502 6.53314 7.79378 6.53314 10.4286C6.53314 10.6542 6.54144 10.8824 6.55738 11.1112H16.0714C16.0873 10.8824 16.0956 10.6542 16.0956 10.4286C16.0956 7.79378 13.9508 5.6502 11.3144 5.6502Z"
          fill="#4BCFFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.53296 10.4286C6.53296 7.79376 8.67784 5.65015 11.3142 5.65015C13.9506 5.65015 16.0955 7.79376 16.0955 10.4286C16.0955 10.6541 16.0872 10.8823 16.0712 11.1112H6.5572C6.54126 10.8823 6.53296 10.6541 6.53296 10.4286Z"
          fill="#4BCFFF"
          fillOpacity="0.15"
        />
        <path
          d="M22.3891 18.164C22.3891 15.7079 20.3945 13.714 17.9391 13.714C15.4829 13.714 13.489 15.7078 13.489 18.164C13.489 20.6195 15.483 22.6141 17.9391 22.6141C20.3944 22.6141 22.3891 20.6194 22.3891 18.164Z"
          fill="white"
          stroke="#3377FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4748 18.884L16.9294 20.3385C17.1708 20.58 17.5621 20.58 17.8035 20.3385L20.7126 17.4294C20.954 17.188 20.954 16.7967 20.7126 16.5553C20.4712 16.3138 20.0799 16.3138 19.8384 16.5553L17.3664 19.0273L16.349 18.0098C16.1075 17.7683 15.7163 17.7683 15.4748 18.0098C15.2333 18.2512 15.2333 18.6425 15.4748 18.884Z"
          fill="#3377FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_472_2067">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 -0.000244141)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
